import React from "react";
import './Teoria.css';
import falaelektromag from "../Images/Fala elektromagnetyczna.png";
import falaMechaniczna from "../Images/Fala mechaniczna.png";
import progSlyszalnosci from "../Images/Prog Slyszalnosci i Bolu.png";
import uchoCzlowieka from "../Images/Ucho Czlowieka.png";
import falaPoprzeczna from "../Images/Fala poprzeczna.png";
import falaPodluzna from "../Images/Fala podluzna.png";
import falaPlaska from "../Images/Fala Plaska 2.png";
import falaKulista from "../Images/Fala Kulista.png";
import falaKolista from "../Images/Fala Kolista.png";

export default function Teoria(){
    return(
      <div className='bigContainerTheory'>
        <div className='theoryContainer'>
          <h1>Rodzaje fal (podział 1):</h1>

          <br/>
          <ul>
              <li>fala płaska</li>
              <li>fala kolista (powierzchniowa)</li>
              <li>fala kulista (przestrzenna)</li>
          </ul>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Fala płaska</h1>
          <br/>

          <p>Fala płaska jest to fala, której powierzchnie falowe tworzą równoległe do siebie linie proste, gdy fala rozchodzi się
              po powierzchni, lub płaszczyzny, gdy rozchodzi się w przestrzeni trójwymiarowej.</p>

          <img src={falaPlaska} className='image'/>

          <br/><br/>
          <h1>Fala kolista</h1>

          <br/>
          <p>Fala kolista jest to fala, której powierzchnie falowe tworzą okręgi, gdy fala rozchodzi się po powierzchni. Im gęściej
              są położone źródła fal, tym bardziej fala wypadkowa będzie przypominać falę płaską.</p>

          <img src={falaKolista} className='image'/>

          <br/><br/>

          <h1>Fala kulista</h1>

          <p>Fala kulista jest to fala, której powierzchnie falowe tworzą powierzchnię kulistą, gdy rozchodzi się w przestrzeni
              trójwymiarowej. Im gęściej są położone źródła fal, tym bardziej fala wypadkowa będzie przypominać falę płaską.
          </p>

          <img src={falaKulista} className='image'/>


          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Rodzaje fal (podział 2):</h1>

          <ul>
              <li>fala poprzeczna</li>
              <li>fala podłużna</li>
          </ul>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Fala poprzeczna</h1>

          <br/>

          <p>Fala poprzeczna jest to fala, której kierunek drgań jest prostpadły do kierunku rozchodzenia się fali.</p>

          <img src={falaPoprzeczna} className='image'/>

          <br/><br/>

          <h1>Fala podłużna</h1>

          <br/>

          <p>Fala podłużna jest to fala, której kierunek drgań jest równoległy (zgodny) z kierunkiem rozchodzenia się fali.</p>

          <img src={falaPodluzna} className='image'/>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Rodzaje Fal (podział 3):</h1>

          <ul>
              <li>fala mechaniczna</li>
              <li>fala elektromagnetyczna</li>
          </ul>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Fala mechaniczna</h1>

          <br/>

          <p>Fala mechaniczna jest to zaburzenie rozchodzące się w ośrodku sprężystym dzięki przekazywaniu ruchu drgającego przez
              cząsteczki tworzące ośrodek. Ośrodek nie przemieszcza się wraz z falą, jedynie jego elementy wykonują drgania w
              ograniczonym obszarze.</p>

          <p>
              <img className='image' src={falaMechaniczna}/>
          </p>

          <br/><br/>

          <h1 className='trzydziestka'>Fala elektromagnetyczna</h1>

          <br/>

          <p>Fala elektromagnetyczna jest to zaburzenie pola elektromagnetycznego rozchodzące się w przestrzeni, nazywane inaczej
              promieniowaniem elektromagnetycznym.</p>

          <p>
              <img className='image' src={falaelektromag}/>
          </p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Dźwięk</h1>

          <br/>

          <p>Dźwięk jest to zaburzenie mechaniczne w ośrodku sprężystym wywołujące subiektywne wrażenie słuchowe u człowieka
              lub zwierząt</p>

          <br/><br/>

          <h1>Akustyka</h1>

          <br/>

          <p>Akustyka jest to dział nauki zajmujący się badaniem fal dźwiękowych: ich powstawaniem, sposobem rozprzestrzeniania się
              w różnych ośrodkach, ich praktycznym wykorzystaniem, a także oddziaływaniem na człowieka i środowisko.</p>

          <br/><br/>

          <h1>Fala dźwiękowa</h1>

          <br/>

          <p>Fala (akustyczna) dźwiękowa jest to podłużna fala mechaniczna, która może rozchodzić się w ośrodkach sprężystych.
              Fala dźwiękowa nie rozchodzi się w próżni.</p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Zakres słyszalności</h1>

          <br/>

          <p>Zakres częstotliwości, które człowiek może słyszeć nazywamy zakresem słyszalności. Rozciąga się on mniej więcej od 20 Hz
              do 20 kHz. Fale akustyczne o niższej częstotliwości od 20 Hz nazywamy infradźwiękami, a większej od 20 kHz ultradźwiękami.</p>

          <br/><br/>

          <h1>Infradźwięki</h1>

          <br/>

          <p>Infradźwięki inaczej poddźwięki są to fale spręzyste o częstotliwości mniejszej niż 20 Hz (poniżej dolnej granicy dźwięków
              słyszalnych). Naturalnymi źródłami infradźwięków są np. zawirowania powietrza, porywy wiatru, wyładowania elektryczne w
              atmosferze, falowania powierzchni mórz, trzęsienia ziemi. Sztucznymi zaś są np. eksplozje, duże drgające elementy
              konstrukcji maszyn, budynków i urządzeń mechanicznych.</p>

          <br/>

          <p>Infradźwięki są słabo tłumione i mogą rozchodzić się na duże odległości. Dlatego wykorzystuje się je do wyznaczenia
              miejsc wybuchów, badania warstw atmosfery, hydrosfery i skorupy ziemskiej. Niestety infradźwięki o dużych natężeniach
              wpływają ujemnie na organizmy żywe.</p>

          <br/><br/>

          <h1>Ultradźwięki</h1>

          <br/>

          <p>Ultradźwięki inaczej naddźwięki są to fale sprężyste o częstotliwości od 20 kHz (powyżej górnej granicy dźwięków
              słyszalnych) do 1 GHz (górna granica jest umowna). Powyżej górnej granicy ultradźwięków zaczynają się hiperdźwięki.</p>

          <br/>

          <p>Ultradźwięki powodują zmiany nieodwracalne lub częściowo nieodwracalne w ośrodku poddanym ich działaniu. Stosuje
              się je np. do obróbki twardych i kruchych materiałów, spawania, otrzymywania stopów ze składników różniących się
              znacznie temperaturą topnienia i gęstością, czyszczenia powierzchni, oczyszczania gazów, otrzymywania emulsji,
              aerozoli, przyspieszania i wzmagania wzrostu roślin, rozbijania kamieni nerkowych, żółciowych, chirurgia ultradźwiękowa.</p>

          <br/><br/>

          <h1>Słuch człowieka</h1>

          <br/>

          <p>Zmysł słuchu człowieka bardzo dobrze odbiera fale dźwiękowe w określonym zakresie częstotliwości. Kiedy człowiek
              się starzeje, to zakres częstotliwości przez niego słyszanych maleje.
              Każdy człowiek słyszy w trochę innym zakresie częstotliwości, ale i czułość jego słuchu na dźwięki o różnym natężeniu
              różni się.</p>

          <br/>

          <p>Kondycję słuchu człowieka można zmierzyć stosując specjalistyczny przyrząd, audiometr, który sporządza wykres czułości
              słuchu i zakresu słyszenia. Statystycznie ludzie szczególnie dobrze słyszą dźwięki o częstotliwościach od 1 kHz do 3,5
              kHz nawet, jeżeli są one ciche.</p>

          <br/><br/>

          <h1>Próg bólu</h1>

          <br/>

          <p>Próg bólu jest to ciśnienie akustyczne, przy którym odczuwany jest ból ucha. Próg bólu jest słabo zależny od częstotliwości
              i wynosi 140 dB dla dźwięków sinusoidalnych oraz 120 dB dla szumów akustycznych.</p>

          <br/><br/>

          <h1>Próg słyszalności</h1>

          <br/>

          <p>Próg słyszalności jest to najniższy poziom ciśnienia akustycznego tonu o określonej częstotliwości, który wywołuje u
              danego słuchacza wrażenie słuchowe.</p>

          <p>
              <img className='image' src={progSlyszalnosci}/>
          </p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Zmysł słuchu</h1>

          <br/>

          <p>Przekształcenie docierającej do ucha fali daje wrażenie dźwięku. Nazywamy to zjawisko słyszeniem.
              Fala akustyczna wywołuje drgania błony bębenkowej, które przenoszone są do kosteczek słuchowych, a następnie do
              znajdującego się w ślimaku kostnym narządu spiralnego Cortiego. Komórki narządu Cortiego pokryte są rzęskami wrażliwymi
              na częstotliwości akustyczne, które przekazują informacje o drganiach nerwem słuchowym do mózgu. Proces odbierania dźwięków
              z otoczenia jest skomplikowany. Posiadanie pary uszu umożliwia ocenienie kierunku, z którego dochodzi dźwięk. Zmysł słuchu
              jest przystosowany do koncentracji uwagi na wybranych dźwiękach, równocześnie eliminując inne zakłócające dźwięki.</p>

          <p>
              <img src={uchoCzlowieka} className='image'/>
          </p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Skąd się bierze dźwięk?</h1>

          <br/>

          <p>Źródła dźwięku:</p>

          <ul>
              <li>drgania strun, np.: gitarowych, skrzypcowych, głosowych</li>
              <li>pręty, płyty, membrany, np.: ksylofon, bęben</li>
              <li>zamknięte lub otwarte słupy powietrza, np.: piszczałki, organy, klarnety</li>
              <li>nagłe zagęszczenia lub rozrzedzenia powietrza, np.: wybuch</li>
          </ul>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Opisywanie dźwięku</h1>

          <br/><br/>

          <h1>Elementy fali dźwiękowej:</h1>

          <br/>

          <ul>
              <li>promień fali dźwiękowej</li>
              <li>źródło drgań fali dźwiękowej</li>
              <li>powierzchnia falowa fali dźwiękowej</li>
              <li>czoło fali dźwiękowej</li>
          </ul>

          <br/><br/>

          <h1>Promień fali dźwiękowej</h1>

          <br/>

          <p>Promień fali dźwiękowej jest to prosta wyznaczająca kierunek rozchodzenia się fali.</p>

          <br/><br/>

          <h1>Źródło drgań fali dźwiękowej</h1>

          <br/>

          <p>Źródło drgań fali dźwiękowej jest to ciało, które przekazuje drgania cząsteczkom ośrodka.</p>

          <br/><br/>

          <h1>Powierzchnia falowa fali dźwiękowej</h1>

          <br/>

          <p>Powierzchnia falowa fali dźwiękowej jest to zbiór punktów sąsiadujących ze sobą i drgających w tej samej fazie.</p>

          <br/><br/>

          <h1>Czoło fali dźwiękowej</h1>

          <br/>

          <p>Czoło fali dźwiękowej jest to powierzchnia falowa najbardziej oddalona od źródła drgań.</p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Subiektywne cechy dźwięku</h1>

          <br/>

          <p>Subiektywne cechy dźwięku:</p>

          <br/>

          <ul>
              <li>wysokość dźwięku</li>
              <li>barwa dźwięku</li>
              <li>głośność dźwięku</li>
          </ul>

          <br/><br/>

          <h1>Wysokość dźwięku</h1>

          <br/>

          <p>Wysokość dźwięku jest to subiektywna cecha wrażenia słuchowego, która zależy głównie od częstotliwości danego dźwięku.
              Wyznacza położenie dźwięku na skali muzycznej. Wysokość dźwięku rośnie wraz ze wzrostem częstotliwości, a w dźwiękach
              głośnych o niskiej częstotliwości wysokość dźwięku zależy również od jego natężenia. Jednostką wysokości dźwięku jest mel.</p>

          <br/><br/>

          <h1>Barwa dźwięku</h1>

          <br/>

          <p>Barwa dźwięku inaczej tembr jest to subiektywna cecha wrażenia słuchowego, która pozwala odróżnić brzmienia różnych
              instrumentów lub głosów. Uzależniona jest od ilości, rodzaju i natężenia tonów składowych. Wynika to z faktu, że barwa
              dźwięku jest związana ze spektrum harmonicznym. Barwa danego instrumentu może zmieniać się nieznacznie w zależności od:
              sposobu wzbudzania drgań, siły wzbudzania, częstotliwości, zmian w czasie.</p>

          <br/><br/>

          <h1>Głośność dźwięku</h1>

          <br/>

          <p>Głośność dźwięku jest to subiektywna cecha wrażenia słuchowego, która umożliwia odróżnianie dźwięków cichszych i
              głośniejszych. Czasami tą cechę nazywamy również amplitudą lub siłą ludzkiego głosu. Głośność dźwięku zależy od:
              ciśnienia akustycznego, struktury widmowej, czasu trwania. Wrażenie głośności określa się przez poziom głośności w
              fonach lub przez głośność w sonach.</p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Obiektywne wielkości charakteryzujące dźwięk:</h1>

          <br/>

          <ul>
              <li>amplituda fali dźwiękowej</li>
              <li>częstotliwość fali dźwiękowej</li>
              <li>okres fali dźwiękowej</li>
              <li>ciśnienie akustyczne</li>
              <li>długość fali dźwiękowej</li>
              <li>szybkość rozchodzenia się fali dźwiękowej</li>
              <li>skala decybelowa</li>
          </ul>

          <br/><br/>

          <h1>Amplituda fali dźwiękowej</h1>

          <br/>

          <p>Amplituda fali dźwiękowej jest to największe wychylenie z położenia równowagi.</p>

          <br/><br/>

          <h1>Częstotliwość fali dźwiękowej</h1>

          <br/>

          <p>Częstotliwość fali dźwiękowej jest to liczba cykli zjawiska okresowego występujących w jednostce czasu.</p>

          <br/><br/>

          <h1>Okres fali dźwiękowej</h1>

          <br/>

          <p>Okres fali dźwiękowej jest to czas wykonania jednego pełnego drgania w ruchu drgającym, czyli czas pomiędzy występowaniami
              tej samej fazy ruchy drgającego.</p>

          <br/><br/>

          <h1>Ciśnienie akustyczne</h1>

          <br/>

          <p>Ciśnienie akustyczne jest to zmienne w czasie odchylenie od średniej wartości ciśnienia statycznego panującego w
              ośrodku sprężystym, występujące podczas rozchodzenia się w nim fali akustycznej. Ciśnienie akustyczne opisuje
              natężenie dźwięku.</p>

          <br/><br/>

          <h1>Długość fali dźwiękowej</h1>

          <br/>

          <p>Długość fali dźwiękowej jest to najmniejsza odległość między 2 punktami o takiej samej fazie.</p>

          <br/><br/>

          <h1>Szybkość rozchodzenia się fali dźwiękowej</h1>

          <br/>

          <p>Szybkość rozchodzenia się fali dźwiękowej jest to szybkość rozchodzenia się podłużnego zaburzenia mechanicznego w
              ośrodku sprężystym.</p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Skala decybelowa</h1>

          <br/>

          <p>Skala decybelowa jest to skala logarytmiczna, służąca do pomiaru natężenia fali dźwiękowej.</p>

          <br/><br/>

          <h1>Charakterystyka fali dźwiękowej</h1>

          <br/>

          <p>Charakterystyka fali dźwiękowej:</p>
          <br/>

          <ul>
              <li>grzbiet fali dźwiękowej</li>
              <li>dolina fali dźwiękowej</li>
              <li>długość fali dźwiękowej</li>
          </ul>

          <br/><br/>

          <h1>Grzbiet fali dźwiękowej</h1>

          <br/>

          <p>Grzbiet fali dźwiękowej jest to maksymalne górne wychylenie cząsteczek ośrodka z położenia równowagi.</p>

          <br/><br/>

          <h1>Dolina fali dźwiękowej</h1>

          <br/>

          <p>Dolina fali dźwiękowej jest to maksymalne dolne wychylenie cząsteczek ośrodka z położenia równowagi.</p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Długość fali dźwiękowej</h1>

          <br/>

          <p>Długość fali dźwiękowej jest to droga jaką przebywa fala w ciagu jednego okresu (wzorek lambda = v * T).</p>

          <br/><br/>

          <h1>Podstawowe zjawiska towarzyszące rozchodzeniu się fal dźwiękowych:</h1>

          <br/>

          <p>Podstawowe zjawiska towarzyszące rozchodzeniu się fal dźwiękowych:</p>

          <br/>

          <ul>
              <li>odbicie fal dźwiękowych</li>
              <li>ugięcie fal dźwiękowych</li>
              <li>interferencja fal dźwiękowych</li>
              <li>dudnienie</li>
              <li>pogłos</li>
              <li>echo</li>
              <li>rezonans akustyczny</li>
              <li>hałas</li>
          </ul>

          <br/><br/>

          <h1>Odbicie fal dźwiękowych</h1>

          <br/>

          <p>Kiedy fala napotyka na nieprzenikliwą przeszkodę, to ulega odbiciu według ogólnych praw odbicia fal.</p>

          <br/><br/>

          <h1>Echo</h1>

          <br/>

          <p>Echo podczas zjawiska odbicia dźwięku występuje, jeśli fala głosowa powraca do ucha obserwatora.
              Mierząc czaspomiędzy nadanie a odbiorem fali dźwiękowej, można ustalić odległość pomiędzy przeszkodą odbijającą a uchem
              obserwatora.</p>

          <br/><br/>

          <h1>Ugiecie fal dźwiękowych</h1>

          <br/>

          <p>Kiedy fala napotka na odpowiednio wąską szczelinę w przegrodzie, to ulega ugięciu.
              Jeśli szerokość szczeliny jest podobna do długości fali, to po przejściu przez nią powstaje fala kolista.
              Fala ulega ugięciu również na krawędziach przeszkody.</p>

          <br/><br/>

          <h1>Interferencja fal dźwiękowych</h1>

          <br/>

          <p>Fale, które rozchodzą sie w tym samym ośrodku i pochodzą z przynajmniej 2 różnych źródeł nakładają się na siebie
              (interferują ze sobą). Powstaje wtedy fala wypadkowa z nakładających się fal składowych.
              Skutkiem nakładania się fal są wzmocnienia (gdy spotykają się zgodnymi fazami - grzebiet z grzebietem, dolina z doliną)
              lub wygaszenia (gdy spotykają się przeciwnymi fazami - grzbiet z doliną).
              Interferencję nazywamy destruktywną, jeśli dochodzi do wygaszenia, a konstruktywną, jeśli dochodzi do wzmocnienia.</p>

          <br/>

          <p>Nakładaniem się fal (superpozycją) wiąże się zasada superpozycji fal:
              wychylenie cząstki ośrodka jest sumą wychyleń wynikających z drgań fal pochodzących z różnych źródeł.</p>

          <br/><br/>

          <h2>Interferencja fal z 2 puntkowych źródeł</h2>

          <br/>

          <p>r2 - r1 = m * lambda</p>

          <br/>

          <p>m = 0, +/- 1, +/- 2, ...</p>

          <br/>

          <p>r2 - r1 = (m + 1/2 * lambda)</p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Dudnienie</h1>

          <br/>

          <p>Podczas zwiększania się i zmniejszania amplitudy drgania wypadkowego, zachodzącego przy interferencji dwóch drgań
              harmonicznych, których częstotliwości są podobne, powstaje dudnienie. Jeśli nakładające się drgania mają taką samą amplitudę,
              to w wyniku interferencji powstaje drganie wypadkowe, którego amplituda zmienia się od podwójnej wartości amplitudy drgań
              składowych do zera, z częstością dudnienia równą różnicy częstotliwości nakładających się drgań.</p>

          <br/><br/>

          <h1>Pogłos</h1>

          <br/>

          <p>Zjawisko przedłużania czasu trwania dźwięku spowodowane wielokrotnymi odbiciami fal dźwiękowych, które dochodzą do
              ucha obserwatora w czasie mniejszym niż 70 ms i nie są rozróżniane jako echo, nazywamy pogłosem.</p>

          <br/><br/>

          <h1>Rezonans akustyczny</h1>

          <br/>

          <p>Zjawisko rezonansu zachodzące dla fal dźwiękowych nazywamy rezonansem akustycznym. Polega ono na pobieraniu energii
              fal akustycznych przez układ akustyczny ze źródła drgań o częstotliwościach równych lub podobnych do częstotliwości
              drgań własnych układu. Wynikiem tego może być generowanie, wzmacnianie lub filtrowanie drgań o tych częśtotliwościach.</p>

          <br/><br/>

          <h1>Hałas</h1>

          <br/>

          <p>Dźwięk niepożądany przez obserwatora, którego działanie jest uciążliwe lub szkodliwe dla niego, nazywamy hałasem.
              Hałasy można podzielić na dwie grupy:</p>

          <br/>

          <ul>
              <li>hałasy ciągłe, w których jest nieznaczna zmiana natężenia i widma częstotliwości w czasie. Przykładami są szmer i szum.</li>
              <li>hałasy impulsowe, w których jest duża zmiana natężenia i widma częstotliwości w czasie. Przykładami są huk i trzask.</li>
          </ul>

          <br/>

          <p>Szkodliwość hałasu zależy od kilku czynników:</p>

          <br/>

          <ul>
              <li>natężenia</li>
              <li>widma częstotliwości</li>
              <li>charakteru zmian w czasie</li>
              <li>zawartości składowych niesłyszalnych (głównie są to infradźwięki)</li>
              <li>długotrwałość działania</li>
          </ul>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Podział zjawisk akustycznych:</h1>

          <br/>

          <ul>
              <li>tony</li>
              <li>dźwięki</li>
              <li>szumy</li>
              <li>huk</li>
          </ul>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Ton</h1>

          <br/>

          <p>Dźwięk prosty, akustyczną falę harmoniczną, monochromatyczną nazywamy tonem. Najważniejszą cechą tonu
              jest jego częstotliwość, która określa wysokość dźwięków granych przez instrumenty. Od amplitudy fali
              akustycznej zależy czy ton będzie silniejszy czy słabszy. Wszystkie dźwięki są falą złożoną z wielu
              tonów o różnych amplitudach i częstościach. To one decydują o barwie danego dźwięku.</p>

          <br/><br/>

          <h1>Dźwięk</h1>

          <br/>

          <p>Dźwięk inaczej fala dźwiękowa lub fala akustyczna jest rozprzestrzenianiem się w sprężystym ośroku
              materialnym zaburzenia stanu równowagi ciśnienia lub naprężeń. Z tymi zaburzeniem związane są mechaniczne
              oscylacje cząstek ośrodka.</p>

          <br/><br/>

          <h1>Szum</h1>

          <br/>

          <p>Chaotyczne, nieprzewidywalne i niepożądane sygnały lub przypadkowe, niemożliwe do przewidzenia zmiany (fluktuacje)
              określonego sygnału nazywamy szumem.</p>

          <br/>

          <p>Szum aktustyczny jest to dźwięk nieharmoniczny o ciągłym widmie częstotliwości, czyli składający się z dużej
              ilości dźwięków o niewielkiej różnicy w częstoliwościach. Przykładami źródeł szumu akustycznego są: burzliwe
              przepływy cieczy lub gazów i wyładowania elektryczne.</p>

          <br/><br/>
          <hr/>
          <br/><br/>

          <h1>Fala akustyczna</h1>

          <br/>

          <p>Rozchodzące się w postaci fali podłużnej zaburzenie w ośrodku sprężystym i polegające na chwilowych zmianach
              gęstości ośrodka, co jest przyczyną chwilowych lokalnych różnic ciśnienia rozchodzących się w ośrodku, nazywamy
              falą akustyczną.</p>

          <br/>

          <p>Podczas zaburzeń transportowana jest energia mechaniczna przez drgające cząsteczki ośrodka, dokładniej poprzez
              lokalne zgęszczenia i rozrzedzenia ośrodka, bez przenoszenia materii i bez trwałego przesunięcia zaburzonego ośrodka.</p>

          <br/><br/>

          <h1>Prędkość rozchodzenia się fal akustycznych</h1>

          <br/>

          <p>Najistotniejszym czynnikiem, który wpływa na prędkość rozchodzenia się fal akustycznych jest temperatura ośrodka, w
              którym się rozchodzi dana fala.</p>

          <br/>

          <p>v = v0 * sqrt(1 + t / 273)</p>

          <br/>

          <p>t - tempertatura powietrza wyrażona w stopniach C</p>

          <br/>

          <p>v0 - prędkość w temperaturze 0 stopni C, czyli 331 m/s</p>

          <br/>

          <p>Istnieje związek pomiędzy prędkością fal akustycznych a częstotliwością i długością fali:</p>

          <br/>

          <p>v = lambda * f</p>
      </div>
        </div>
    );
}